/* eslint-disable import/no-duplicates */
import React from 'react';
import ReactDOM from 'react-dom';
// tslint:disable-next-line:no-submodule-imports
import './index.scss';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { history } from './store/store';
import './i18n';

import { AppConfig } from './types/app.index';

declare global {
  interface Window { config: AppConfig }
}

window.config = window.config || {};

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
